
namespace RioERP.Invoices {
    export class InvoicePaymentColumns {
        static columnsKey = 'Invoices.InvoicePayment';
    }
}